/*
 * The CSS in index.css already blocks selection; these listeners cover the two
 * routes that bypass it entirely — the right-click "Save image as…" menu and
 * dragging media straight out of the page onto the desktop. Text inputs keep
 * their native context menu so spellcheck, paste and autofill still work.
 */

const MEDIA_SELECTOR = 'img, video, picture, svg'
const EDITABLE_SELECTOR = 'input, textarea, select, [contenteditable="true"]'

function isEditable(target: EventTarget | null): boolean {
  return target instanceof Element && target.closest(EDITABLE_SELECTOR) != null
}

export function installContentProtection(): void {
  if (typeof document === 'undefined') return

  document.addEventListener('contextmenu', (event) => {
    if (isEditable(event.target)) return
    if (event.target instanceof Element && event.target.closest(MEDIA_SELECTOR)) {
      event.preventDefault()
    }
  })

  document.addEventListener('dragstart', (event) => {
    if (isEditable(event.target)) return
    event.preventDefault()
  })
}
